import {
  bgAustralia,
  bgCanada,
  bgDenamrk,
  bgGermany,
  bgHungary,
  bgLativa,
  bgMalasiya,
  bgRussia,
  bgSweden,
  bgUnitedKingdom,
  bgUnitedStates,
} from "../Shared/Images/image";
const countries = [
  {
    name: "Germany",
    shortName: "GER",
    imageUrl: bgGermany,
    programs: [
      {
        name: "underGraduate",
        minMarks: 60,
        maxMarks: 60,
        minIelts: 6,
        maxIelts: 6,
      },
      {
        name: "masters",
        minMarks: 60,
        maxMarks: 60,
        minIelts: 6.5,
        maxIelts: 6.5,
      },
      {},
    ],
  },
  {
    name: "Norway",
    shortName: "NOR",
    imageUrl: bgAustralia,
    programs: [
      {
        name: "underGraduate",
        minMarks: 60,
        maxMarks: 60,
        minIelts: 6,
        maxIelts: 6,
      },
      {
        name: "masters",
        minMarks: 60,
        maxMarks: 60,
        minIelts: 6.5,
        maxIelts: 6.5,
      },
      {},
    ],
  },
  {
    name: "Denmark",
    shortName: "DEN",
    imageUrl: bgDenamrk,
    programs: [
      {
        name: "underGraduate",
        minMarks: 60,
        maxMarks: 60,
        minIelts: 6,
        maxIelts: 6.5,
      },
      {
        name: "masters",
        minMarks: 60,
        maxMarks: 60,
        minIelts: 6.5,
        maxIelts: 6.5,
      },
      {},
    ],
  },
  {
    name: "Hungary",
    shortName: "HUNG",
    imageUrl: bgHungary,
    programs: [
      {},
      {
        name: "masters",
        minMarks: 60,
        maxMarks: 60,
        minIelts: 0,
        maxIelts: 0,
      },
      {},
    ],
  },
  {
    name: "United States",
    shortName: "USA",
    imageUrl: bgUnitedStates,
    programs: [
      {
        name: "underGraduate",
        minMarks: 0,
        maxMarks: 0,
        minIelts: 6,
        maxIelts: 6.5,
      },
      {
        name: "masters",
        minMarks: 0,
        maxMarks: 0,
        minIelts: 6,
        maxIelts: 6.5,
      },
      {
        name: "diploma",
        minMarks: 0,
        maxMarks: 0,
        minIelts: 6,
        maxIelts: 6,
      },
    ],
  },
  {
    name: "United Kingdom",
    shortName: "UK",
    imageUrl: bgUnitedKingdom,
    programs: [
      {
        name: "underGraduate",
        minMarks: 0,
        maxMarks: 0,
        minIelts: 6,
        maxIelts: 6,
      },
      {
        name: "masters",
        minMarks: 0,
        maxMarks: 0,
        minIelts: 6.5,
        maxIelts: 6.5,
      },
      {
        name: "diploma",
        minMarks: 50,
        maxMarks: 55,
        minIelts: 0,
        maxIelts: 0,
      },
    ],
  },
  {
    name: "Australia",
    shortName: "AUS",
    imageUrl: bgAustralia,
    programs: [
      {
        name: "underGraduate",
        minMarks: 60,
        maxMarks: 60,
        minIelts: 6,
        maxIelts: 6,
      },
      {
        name: "masters",
        minMarks: 60,
        maxMarks: 60,
        minIelts: 6.5,
        maxIelts: 6.5,
      },
      {},
    ],
  },
  {
    name: "Canada",
    shortName: "CAN",
    imageUrl: bgCanada,
    programs: [
      {
        name: "underGraduate",
        minMarks: 0,
        maxMarks: 0,
        minIelts: 6,
        maxIelts: 6,
      },
      {},
      {
        name: "diploma",
        minMarks: 50,
        maxMarks: 50,
        minIelts: 0,
        maxIelts: 0,
      },
    ],
  },
  {
    name: "Malaysia",
    shortName: "MAS",
    imageUrl: bgMalasiya,
    programs: [
      {
        name: "underGraduate",
        minMarks: 60,
        maxMarks: 60,
        minIelts: 0,
        maxIelts: 0,
      },
      {},
      {},
    ],
  },
  {
    name: "Sweden",
    shortName: "SWE",
    imageUrl: bgSweden,
    programs: [
      {
        name: "underGraduate",
        minMarks: 0,
        maxMarks: 0,
        minIelts: 0,
        maxIelts: 0,
      },
      {},
      {},
    ],
  },
  {
    name: "Latvia",
    shortName: "LAT",
    imageUrl: bgLativa,
    programs: [
      {
        name: "underGraduate",
        minMarks: 0,
        maxMarks: 0,
        minIelts: 0,
        maxIelts: 0,
      },
      {},
      {},
    ],
  },
  {
    name: "Russia",
    shortName: "RUS",
    imageUrl: bgRussia,
    programs: [
      {
        name: "underGraduate",
        minMarks: 0,
        maxMarks: 0,
        minIelts: 0,
        maxIelts: 0,
      },
      {},
      {},
    ],
  },
];

export { countries };

const filterCountries = (program, marks, ielts) => {
  return countries.filter((country) => {
    const cp = findProgram(program, country.programs);
    if (cp) {
      return marks >= cp.minMarks && ielts >= cp.minIelts;
    }
    return false;
  });
};
const findProgram = (program, programs) => {
  return programs.find((item) => item.name === program);
};

// const inBetween = (value, minValue, maxValue) => {
//   return value >= minValue && value <= maxValue;
// };
export { filterCountries };
